<div fxLayoutAlign="end end" class="btnScrollToTop" [ngClass]="{ 'show-scrollTop': windowScrolled }">
    <button mat-mini-fab color="accent" (click)="scrollToTop()">
        <mat-icon class="icon-top">expand_less</mat-icon>
    </button>
</div>